<template>
  <div class="user_page">
    <h3 class="title-page">{{ $t("users") }}</h3>
    <div>
      <div class="admin_container">
        <div class="text-right mb-3">
          <v-btn @click="editItem('add')" color="primary">
            {{ $t("create") }}
          </v-btn>
        </div>
        <table-with-filter
          fixed-header
          :headers="headers"
          :items="users"
          :page="configuration.page"
        >
          <template #item.userPhoto="{ item }">
            <div class="user_img_container">
              <img :src="item.userPhoto" alt="avatar" />
            </div>
          </template>
          <template #filter.firstName>
            <div class="pa-1">
              <custom-input-text
                class="user_input no-margin"
                v-model="filterUser.firstName"
                @input="getFilterUser"
              />
            </div>
          </template>

          <template #filter.tin>
            <div class="pa-1">
              <custom-input-text
                class="user_input no-margin"
                v-model="filterUser.tin"
                @input="getFilterUser"
              />
            </div>
          </template>
          <template #filter.userName>
            <div class="pa-1">
              <custom-input-text
                @input="getFilterUser"
                class="user_input no-margin"
                v-model="filterUser.userName"
              />
            </div>
          </template>
          <template #item.firstName="{ item: { firstName, lastName } }">
            {{ firstName }} {{ lastName }}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip nudge-top="35" nudge-right="10" color="#fff" left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  class="new_style"
                  @click="editItem('update', item)"
                >
                  <vue-icon icon="newPencilIcon" />
                </v-btn>
              </template>
              <span>{{ $t("edit") }}</span>
            </v-tooltip>
            <v-tooltip nudge-top="35" nudge-right="10" color="#fff" left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  dark
                  class="new_style"
                  @click="editItem('delete', item)"
                >
                  <vue-icon icon="newTrashIcon" />
                </v-btn>
              </template>
              <span>{{ $t("delete") }}</span>
            </v-tooltip>
            <v-tooltip nudge-top="35" nudge-right="10" color="#fff" left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  class="new_style"
                  dark
                  @click="editItem('addRole', item)"
                >
                  <vue-icon icon="newUserIcon" />
                </v-btn>
              </template>
              <span>Role Qo'shish</span>
            </v-tooltip>
          </template>
        </table-with-filter>
        <vue-pagination
          @update:limit="
            (limit) => {
              configuration.limit = limit;
              configuration.page = 1;
              changePage();
            }
          "
          v-model="configuration.page"
          :length="lastPage"
          @input="changePage"
          go-to
          :limit="configuration.limit"
        />
        <v-dialog v-model="dialog" max-width="500px">
          <ValidationObserver v-slot="{ handleSubmit }" ref="form">
            <v-form
              @submit.prevent="
                addRoleDialog ? handleSubmit(addRole) : handleSubmit(save)
              "
            >
              <v-card>
                <v-card-title
                  class="d-flex justify-sm-space-between"
                  style="border-bottom: 2px solid #dfe2e9"
                >
                  <span class="headline">{{ formTitle }}</span>

                  <span @click="dialog = false">
                    <vue-icon
                      icon="newBoldCloseIcon"
                      class="cursor-pointer"
                    ></vue-icon>
                  </span>
                </v-card-title>
                <v-card-text>
                  <v-row class="edit_user_table form-row">
                    <template v-if="addRoleDialog === false">
                      <v-col lg="6" cols="12">
                        <CustomInputText
                          rules="required"
                          v-model="editedItem.firstName"
                          :placeholder="$t('firstName')"
                        ></CustomInputText>
                      </v-col>
                      <v-col lg="6" cols="12">
                        <CustomInputText
                          rules="required"
                          v-model="editedItem.lastName"
                          :placeholder="$t('middleName')"
                        ></CustomInputText>
                      </v-col>
                      <v-col lg="6" cols="12">
                        <CustomInputText
                          rules="required"
                          v-model="editedItem.middleName"
                          :placeholder="$t('lastName')"
                        ></CustomInputText>
                      </v-col>
                      <v-col lg="6" cols="12">
                        <CustomInputText
                          prefix="+998"
                          rules="required|phone"
                          v-mask="`(##)-###-##-##`"
                          v-model="editedItem.phone"
                          :placeholder="$t('phone')"
                        ></CustomInputText>
                      </v-col>
                      <v-col lg="6" cols="12">
                        <CustomInputText
                          rules="required|length:9|numeric"
                          v-mask="`#########`"
                          v-model="editedItem.tin"
                          placeholder="Tin"
                        ></CustomInputText>
                      </v-col>
                      <v-col lg="6" cols="12">
                        <vue-select
                          ref="departmentSelectRef"
                          infinite
                          :get-item-promise="
                            ({ text, page }) =>
                              $store.dispatch('getDepartments', {
                                name: text,
                                page,
                                limit: 15,
                              })
                          "
                          @item-resolved="setDepartment"
                          @next-page-resolved="
                            (data) => setDepartment([...departments, ...data])
                          "
                          class="user_input no-margin product-select-in-modal"
                          :clearable="false"
                          :items="departments"
                          v-model="editedItem.departmentId"
                          :placeholder="$t('department')"
                          :name="$t('department')"
                        ></vue-select>
                      </v-col>
                      <v-col lg="6" cols="12">
                        <CustomInputText
                          rules="required"
                          v-model="editedItem.userName"
                          :placeholder="$t('userName')"
                        ></CustomInputText>
                      </v-col>
                      <v-col lg="6" cols="12">
                        <validation-provider
                          v-slot="{ errors }"
                          :name="$t('file')"
                          rules="required|document|not_empty_file"
                        >
                          <v-file-input
                            v-model="editedItem.file"
                            prepend-icon="mdi-camera"
                            :error-messages="errors[0]"
                            :label="$t('attachFile') + '*'"
                          ></v-file-input>
                        </validation-provider>
                      </v-col>
                      <v-col lg="6" cols="12">
                        <CustomInputText
                          mode="passive"
                          type="password"
                          :rules="{
                            required: !editedItemId,
                            confirmed: {
                              value: editedItem.confirmPassword,
                              fieldName: $t('password'),
                            },
                          }"
                          v-model="editedItem.password"
                          :placeholder="$t('password')"
                        ></CustomInputText>
                      </v-col>
                      <v-col lg="6" cols="12">
                        <CustomInputText
                          mode="passive"
                          :rules="{ required: !editedItemId }"
                          type="password"
                          v-model="editedItem.confirmPassword"
                          :placeholder="$t('confirmPassword')"
                        ></CustomInputText>
                      </v-col>
                    </template>
                    <template v-else-if="addRoleDialog">
                      <v-col cols="12">
                        <span class="text--accent-1 blue-dark--text"
                          >{{ $t("roles") }}
                        </span>
                        <validation-provider
                          :name="$t('roles')"
                          v-slot="{ errors }"
                        >
                          <input type="hidden" v-model="editedItem.roles" />
                          <span
                            class="d-block v-messages error--text"
                            v-if="errors[0]"
                            >{{ errors[0] }}</span
                          >
                        </validation-provider>
                        <div class="d-flex ma-n2 flex-wrap">
                          <div
                            class="pa-2"
                            :key="`role-${item.id}`"
                            v-for="item in roles"
                          >
                            <v-checkbox
                              class="my-0 form-checkbox"
                              hide-details
                              :value="item.id"
                              v-model="editedItem.roles"
                              :label="item.name"
                            ></v-checkbox>
                          </div>
                        </div>
                      </v-col>
                    </template>
                  </v-row>
                </v-card-text>
                <v-card-actions class="footer_modal_user">
                  <v-spacer></v-spacer>
                  <v-btn
                    color="#9EABBE"
                    style="width: 50%"
                    dark
                    @click="close"
                    >{{ $t("toCancel") }}</v-btn
                  >
                  <v-btn
                    color="primary"
                    style="width: 50%"
                    dark
                    type="submit"
                    >{{ $t("save") }}</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-form>
          </ValidationObserver>
        </v-dialog>
        <warning-dialog
          v-model="deleteDialog"
          @apply="deleteItem"
        ></warning-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import warningDialog from "@/components/ui/prompt/warning-dialog";
import { VueMaskDirective } from "v-mask";
import {
  debounce,
  makerPagination,
  parsePhoneFormat,
} from "@/utils/pureFunctions";
import VueSelect from "@/components/ui/vue-select/VueSelect";
import TableWithFilter from "@/components/ui/table/TableWithFilter";
import VuePagination from "@/components/ui/vue-pagination/VuePagination";

import { formDataMaker } from "@/utils/pureFunctions";

export default {
  data() {
    return {
      users: [],
      roles: [],
      departments: [],
      editedItem: {
        tin: null,
        firstName: null,
        lastName: null,
        middleName: null,
        password: null,
        phone: null,
        file: null,
        roles: [],
        userName: null,
        departmentId: null,
      },
      editedItemId: null,
      addRoleDialog: false,
      deleteDialog: false,
      dialog: false,
      configuration: {
        page: 1,
        limit: 15,
      },
      lastPage: 0,
      filterUser: {
        firstName: null,
        tin: null,
        userName: null,
      },
    };
  },
  watch: {
    dialog(val) {
      if (!val) {
        const { form } = this.$refs;
        this.editedItem = {
          tin: null,
          firstName: null,
          lastName: null,
          middleName: null,
          password: null,
          phone: null,
          userName: null,
        };
        this.editedItemId = null;
        if (form) form.reset();
      }
    },
  },
  methods: {
    setDepartment(departments) {
      this.departments = departments;
    },
    getFilterUser: debounce(async function () {
      this.showLoading();
      this.configuration.page = 1;
      await this.getUsers();
      this.clearLoading();
    }, 300),
    async changePage(value) {
      const { page: queryPage } = this.$route.query;
      if (queryPage !== value.toString()) {
        this.showLoading();
        await this.$router.push({ query: { page: value.toString() } });
        this.configuration.page = value;
        await this.getUsers();
        this.clearLoading();
      }
    },
    async getUsers() {
      try {
        const { limit, page } = this.configuration;
        let params = {
          page: page - 1,
          limit,
          ...this.filterUser,
        };
        const {
          data: { data, total },
        } = await this.$http.get("user/list", { params });
        this.users = data.map((user) => {
          if (user.phone) {
            user.phone = parsePhoneFormat(user.phone).format("short");
          }
          return user;
        });
        this.lastPage = makerPagination({ limit, total }).lastPage;
      } catch (e) {
        this.setResponseError({ error: e });
      }
    },
    clearModal() {
      this.editedItem = {
        name: "",
      };
    },
    editItem(type, item) {
      if (type === "add") {
        this.departments = [];
        this.addRoleDialog = false;
        this.dialog = true;
        this.$nextTick(() => {
          this.$refs.departmentSelectRef.reset();
        });
      } else if (type === "update") {
        this.addRoleDialog = false;
        this.departments = [
          { id: item.departmentId, name: item["departmentName"] },
        ];
        this.editedItem = {
          id: item.id,
          tin: item.tin,
          firstName: item.firstName,
          lastName: item.lastName,
          middleName: item.middleName,
          password: null,
          phone: item.phone,
          userName: item.userName,
          departmentId: item.departmentId,
        };
        this.editedItemId = item.id;
        this.dialog = true;
        this.$nextTick(() => {
          this.$refs.departmentSelectRef.reset();
        });
      } else if (type === "delete") {
        this.editedItem = item;
        this.deleteDialog = true;
      } else if (type === "addRole") {
        this.dialog = true;
        this.addRoleDialog = true;
        this.editedItem = item;
        this.editedItemId = item.id;
      }
    },
    close() {
      this.dialog = false;
    },
    async addRole() {
      try {
        this.showLoading();
        const formData = {
          userId: this.editedItemId,
          roles: this.editedItem.roles,
        };
        await this.$http.post(`user/attach-role`, formData);
        await this.getUsers();
        this.dialog = false;
        this.clearModal();
        this.setSuccess({ text: this.$t("successfullySaved") });
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    async deleteItem() {
      this.showLoading();
      try {
        const { id } = this.editedItem;
        await this.$http.delete(`user/delete`, { params: { objectId: id } });
        this.users = this.users.filter((item) => {
          return item.id !== id;
        });
        this.editedItem = {
          tin: null,
          firstName: null,
          lastName: null,
          middleName: null,
          password: null,
          phone: null,
          userName: null,
        };
        this.setSuccess({
          text: this.$t("successfullyDeleted"),
        });
      } catch (e) {
        this.setResponseError({
          error: e,
        });
      } finally {
        this.clearLoading();
      }
    },
    async save() {
      try {
        this.showLoading();
        const formData = formDataMaker(this.editedItem);
        // delete formData.confirmPassword;
        formData.delete("confirmPassword");
        const parsedPhone = parsePhoneFormat(formData.get("phone"));
        formData.set("phone", parsedPhone.format("full"));
        await this.$http.post("user/save", formData);
        await this.getUsers();
        this.dialog = false;
        this.clearModal();
        this.setSuccess({ text: this.$t("successfullySaved") });
      } catch (e) {
        console.log(e);
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
  },
  computed: {
    formTitle() {
      return this.editedItemId ? this.$t("editGroup") : this.$t("create");
    },
    headers() {
      return [
        {
          text: "User Photo",
          value: "userPhoto",
        },
        {
          text: this.$t("firstName"),
          value: "firstName",
        },
        {
          text: this.$t("tin"),
          value: "tin",
        },
        {
          text: this.$t("login"),
          value: "userName",
        },
        {
          text: this.$t("phone"),
          value: "phone",
        },
        {
          text: this.$t("department"),
          value: "departmentName",
        },
        {
          text: this.$t("action"),
          value: "actions",
        },
      ];
    },
  },
  directives: {
    mask: VueMaskDirective,
  },
  components: {
    VuePagination,
    TableWithFilter,
    VueSelect,
    warningDialog,
  },
  async created() {
    this.showLoading();
    try {
      const { page } = this.$route.query;
      if (page) this.configuration.page = +page;
      const {
        data: { data },
      } = await this.$http.get("role/items");
      this.roles = data;
      await this.getUsers();
    } catch (e) {
      this.setResponseError({ error: e });
    } finally {
      this.clearLoading();
    }
  },
};
</script>

<style scoped lang="scss">
div.v-card {
  display: flex;
  flex-direction: column;
  gap: 20px;

  .v-card__text {
    padding-top: 16px;

    .col-lg-6 {
      margin-bottom: 8px;
    }
  }
}

.user_img_container {
  width: 70px;
  height: 70px;
  margin: auto;
  img {
    width: 100%;
    border-radius: 50%;
  }
}
</style>
